import { React } from 'react'
import Modal from 'react-bootstrap/Modal';
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL

const UpdateAttachment = ({ val, previewImage, attachmentModal, handleClose, attachmentList, previewModal, setAttachmentList, setPreviewModal, setPreviewImage ,ItemCode}) => {

    const handleFileSelect = (event, index) => {
        const file = event.target.files[0];
        if (file) {
            setAttachmentList((prevList) => {
                const updatedList = prevList.map((attachment, idx) =>
                    idx === index
                        ? { ...attachment, fileName: file.name, file: file }
                        : attachment
                );
                if (!updatedList.some((item) => item.fileName === '')) {
                    updatedList.push({ rcno: null, srno: updatedList.length, fileName: '', remarks: '' });
                }

                return updatedList;
            });
        }
    };
    const handleRemarksChange = (value, index) => {
        setAttachmentList((prevList) =>
            prevList.map((attachment, idx) =>
                idx === index ? { ...attachment, remarks: value } : attachment
            )
        );
    };
    const handleView = (file) => {
        
        if (val) {
            if (file) {
                setPreviewImage(file);
                setPreviewModal(true);
            } else {
                console.error("No valid file to preview");
            }
        } else {
            if (file && file instanceof File) {
                setPreviewImage(URL.createObjectURL(file));
                setPreviewModal(true);
            } else {
                console.error("No valid file to preview");
            }
        }
    };
    const handleDelete = (index) => {
        setAttachmentList((prevList) => {
            const updatedList = prevList.filter((_, idx) => idx !== index);
            if (!updatedList.some((item) => item.fileName === '')) {
                updatedList.push({ rcno: null, srno: updatedList.length, fileName: '', remarks: '' });
            }
            return updatedList;
        });
    };
    return (
        <div>
            <Modal show={attachmentModal} size="lg" onHide={handleClose} >
                <Modal.Header closeButton>
                    <Modal.Title>Attachments</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-3 d-flex justify-content-between">
                        <label htmlFor="docNp" className="form-label  pt-2 start">Document No</label>
                        <input disabled value={ItemCode} className="form-Input w-70" />
                    </div>
                    <div className="pt-2">
                        <table>
                            <thead className="dynoTable">
                                <tr>
                                    <th>File Name</th>
                                    <th>Remarks</th>
                                    <th>Upload</th>
                                    <th>View</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attachmentList.map((attachment, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                disabled
                                                value={attachment.fileName}
                                                style={{ width: '320px' }}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                value={attachment.remarks}
                                                onChange={(e) => handleRemarksChange(e.target.value, index)}
                                                style={{ width: '345px' }}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                className="mainbtn"
                                                onClick={() => document.getElementById(`fileInput-${index}`).click()}
                                            >
                                                Upload
                                            </button>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleFileSelect(e, index)}
                                                id={`fileInput-${index}`}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                className="mainbtnRed"
                                                onClick={() => handleView(attachment.file || attachment.fileName)}
                                                disabled={!attachment.fileName}
                                            >
                                                View
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                onClick={() => handleDelete(index)}
                                                disabled={attachment.fileName === '' && attachment.rcno === null}
                                                className="mainbtnSecondary"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='mainbtn ' onClick={handleClose} >Attach</button>
                </Modal.Footer>
            </Modal>
            <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Image Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {val ?
                        <>
                            {previewImage && <img src={IMAGE_URL + previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                        </> :
                        <>
                            {previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                        </>
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default UpdateAttachment
